import {Component} from '@angular/core';

@Component({
  selector: 'ax-logo',
  templateUrl: './logo.component.html',
})
export class LogoComponent {}
